import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {BoidAssignmentState} from "../model";
import {assignmentStatesFromClientEntity} from "./assignmentStatesFromClientEntity";

/**
 * This mapping function produces a flattened collection of {@link BoidAssignmentState} objects
 * using the {@link SubAccount|SubAccounts} of each {@link ClientEntity} as the
 * source of BOID assignment data.
 *
 * @param sources - Array of ClientEntity objects containing SubAccount data
 * @returns Flattened array of BoidAssignmentState objects from all client entities
 * @see {@link assignmentStatesFromClientEntity} - Transforms individual ClientEntity to BoidAssignmentState array
 */
export const collectBoidAssignmentStatesFromClientEntities = (
  sources: ClientEntity[]
): BoidAssignmentState[] => {
  return sources.flatMap(assignmentStatesFromClientEntity);
};
